<template>
  <v-container fluid>
    <v-row>
      <v-btn
      v-if="!isView"
        @click="downloadTransfer"
        small
        outlined
        class="ml-8 rounded text-capitalize"
        tile
        color="primary"
      >
        <v-icon left> print </v-icon>
        Imprimir
      </v-btn>
      <v-btn
      v-else
        @click="isView=false"
        small
        outlined
        class="ml-8 mb-5 rounded text-capitalize"
        tile
        color="primary"
      >
        <v-icon left> print </v-icon>
        Volver
      </v-btn>
    </v-row>

    <div v-if="isView">
      <iframe v-if="pdfUrl" style="min-height: 90vh; width: 100%; position: relative" :src="pdfUrl" frameborder="0"
      allowfullscreen></iframe>
    </div>
    <div v-else>
    

    <v-row justify="center">
      <span class="" style="font-size: 24px; color: #616161"
        >Transferencia inventario
      </span>
    </v-row>
    <v-row justify="center">
      <span class="mx-4 font-weight-bold">
        #{{ filLeft(data_transfer[0].id.toString(), 12, "0") }}
      </span>
    </v-row>
    <v-row>
      <v-row class="mt-2">
        <v-col cols="12" md="8" class="pt-0 mt-0 pb-0">
          <v-card width="100%" min-height="350" outlined>
            <v-card-title class="pb-0 mb-0">
              <v-row class="pb-0 mb-0">
                <v-col cols="12" md="12" class="pb-0 mb-0">
                  <span class="pb-0 mb-0"> Lista de artículos</span>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              <v-row  class="pt-0">
              <v-col cols="12">
                <v-data-table
                  
                  :headers="headersArticle"
                  :search="search"
                  :items="articlesDetail"
                
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <span>Total: {{ articlesDetail.length }}</span>
                      <v-spacer></v-spacer>
                      <v-text-field
                        class="text-xs-center"
                        v-model="search"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        hide-details
                      >
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-divider class="mx-3" inset vertical></v-divider>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.item_image`]="{ item }">
                    <v-avatar size="40">
                      <v-img :src="item.item_image"></v-img>
                    </v-avatar>
                  </template>
                
                  <template v-slot:[`item.quantity_send`]="{ item }">
                    <v-text-field
                      class="text-xs-center"
                      v-model="item.requested_quantity"
                      dense
                      type="number"
                      min="1"
                      :max="item.quantity"
                      @input="checkMaxQuantity(item)"
                    
                    >
                    </v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="pt-0 mt-0 pb-0">
          <v-card v-if="data_transfer" width="100%" min-height="350" outlined>
            <v-card-title class="pb-0 d-flex justify-center"
              >Historico</v-card-title
            >
            <v-divider class="ma-4"></v-divider>
            <v-container fluid>
              <template>
                <v-timeline>
                  <v-timeline-item
                    v-for="item in data_transfer[0].time_line_status"
                    small
                    :key="item.warehouse_approval_type_id"
                    :color="
                      time_line_config(1, item.warehouse_approval_type_id).color
                    "
                    class="pb-0"
                    :icon="
                      time_line_config(1, item.warehouse_approval_type_id).icon
                    "
                  >
                    <template v-slot:opposite>
                      <span>{{ item.use_fullname }}</span>
                    </template>
                    <v-card outlined>
                      <v-card-title
                        class="d-flex justify-center align-center pt-0 pb-0"
                        :class="
                          time_line_config(1, item.warehouse_approval_type_id)
                            .color
                        "
                      >
                        <span style="font-size: 18px; color: #ffffff">
                          {{ dateFormated(item.created_at) }}</span
                        >
                      </v-card-title>
                      <v-card-text>
                        <span class="d-flex justify-center align-center">
                          {{ item.name }}</span
                        >
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </template>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
    <v-row justify="center" class="mt-8" no-gutters>
      <v-col cols="12" md="12">
        <v-row v-if="accounting.length>0" fluid>
          <div class="folded_corner mt-5">
            <v-container>
              <h3 class="text-center">Contabilidad</h3>

              <v-data-table
                v-if="accounting"
                :headers="headersContabilidad"
                :items="accounting"
                class="elevation-0 rounded-lg mt4 mb-4"
                hide-default-footer
                :items-per-page="100"
                style=""
              >
                <template v-slot:[`item.chart_of_account_name`]="{ item }">
                  <span class="primary--text">
                    {{ item.chart_of_account_code }}
                  </span>
                  -
                  <span>
                    {{ item.chart_of_account_name }}
                  </span>
                </template>

                <template v-slot:[`item.debito`]="{ item }">
                  <span v-if="item.entry_type_id == 1">
                    {{ currencyFormat(item.amount) }}
                  </span>
                </template>

                <template v-slot:[`item.credito`]="{ item }">
                  <span v-if="item.entry_type_id == 2">
                    {{ currencyFormat(item.amount) }}</span
                  >
                </template>

                <template slot="body.append">
                  <tr class="mt-2 mb-2">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th
                      class="font-weight-bold"
                      style="color: #616161; font-size: 20px"
                    >
                      TOTAL
                    </th>
                    <!-- <th class="title">{{ sumField("calories") }}</th>
                                <th class="title">{{ sumField("fat") }}</th> -->
                    <th
                      style="font-size: 18px"
                      class="font-weight-normal text-right success--text"
                    >
                      {{
                        currencyFormat(
                          accounting.reduce((acc, entry) => {
                            if (entry.entry_type_id === 1) {
                              return acc + parseFloat(entry.amount);
                            } else {
                              return acc;
                            }
                          }, 0)
                        )
                      }}
                      {{ accounting[0].currency_code }}
                    </th>
                    <th
                      class="font-weight-normal text-right error--text"
                      style="color: #616161; font-size: 18px"
                    >
                      {{
                        currencyFormat(
                          accounting.reduce((acc, entry) => {
                            if (entry.entry_type_id === 2) {
                              return acc + parseFloat(entry.amount);
                            } else {
                              return acc;
                            }
                          }, 0)
                        )
                      }}
                      {{ accounting[0].currency_code }}
                    </th>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </div>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  data: () => ({
    accounting: [],
    headersContabilidad: [
      {
        text: "Asiento",
        align: "start",
        sortable: false,
        value: "diary_book_code",
      },
      { text: "Cuenta", value: "chart_of_account_name" },
      { text: "Location", value: "location_description" },
      { text: "Entidad", value: "entity_name" },
      { text: "Categoria", value: "category_name" },
      { text: "Sub Categoria", value: "subcategory_name" },
      { text: "Debito", value: "debito", align: "right" },
      { text: "Credito", value: "credito", align: "right" },
    ],
    pdfUrl: null,
    isView:false,
    id_transactions: null,
    data_transfer: null,
    data_transactions_entity: [],
    selectedAttached: "",
    headers: [
      {
        text: "Id",
        align: "start",
        sortable: false,
        value: "item_id",
      },
      {
        text: "Articulo",
        value: "name",
      },
      {
        text: "Cantidad anterior",
        value: "old_quantity",
      },
      {
        text: "Cantidad nueva",
        value: "new_quantity",
      },
      {
        text: "Diferencia",
        value: "quantity_difference",
      },
    ],
    search: "",
    articlesDetail: [],
    headersArticle: [

      { text: "ID", value: "item_id" },
      { text: "Articulo", value: "item_name" },
      {
        text: "Cantidad solicitada",
        value: "requested_quantity",
        width: "20%",
        align: "center",
      },
      {
        text: "Cantidad en almacén",
        value: "quantity_aviable",
        width: "20%",
        align: "center",
      },
      {
        text: "Cantidad a enviar",
        value: "quantity_send",
        align: "center",
      },
    
    ],
  }),

  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      const responseRequest = await this.api_Post("inventory/transferDetail", {
        id: this.$route.params.id,
      });
      if (responseRequest.status == 200) {
        let data = await responseRequest.json();

        this.data_transfer = data;

        this.viewDetail(this.data_transfer[0]);
      } else {
        this.$toast.error("error al cargar el pago!");
      }
      const responseAccountig = await this.api_Post(
        "accounting/payment_accounting",
        {
          filters: `  where warehouse_transfer_id =${this.$route.params.id}`,
        }
      );
      if (responseAccountig.status == 200) {
        this.accounting = await responseAccountig.json();
       
      }
      this.loading = false;
    },
    async downloadTransfer()
    {
      this.isView=true
       
       // const responseRequest = await this.api_Post("income/search_invoice_id", {
       //   number: invoice_id,
       // });
       // let data_invoice = "";
       // if (responseRequest.status == 200) {
       //   data_invoice = await responseRequest.json();
     
       // } else {
       //   this.$toast.error("error al cargar la factura!");
       // }
 
       const responseDataPdf = await this.api_Post("inventory/view_transfer", {
         id: this.$route.params.id,
       });
 
       const blob = await responseDataPdf.blob();
       const pdfUrl = URL.createObjectURL(blob);
 
       this.pdfUrl = pdfUrl;
    },
    dateFormated(date) {
      return moment(date).format("DD/MM/YYYY h:mm a");
    },
    async viewDetail(item_request) {
      const request = await this.api_Get(
        "inventory/transfersDetail/" + item_request.id
      );
      const data = await request.json();
      if (request.status == 200) {
        let articles = [];
        for (let item of data) {
        
          articles.push(item);
        }
     
        this.articlesDetail = articles;
      
      } else {
        this.$toast.error("Error al consultar el detalle!." + data.error);
      }
    },
    getDate(item) {
      return moment(item).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.folded-paper:before {
  content: "";
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  position: absolute;
  top: 0;
  right: 0;
  border-width: 0 30px 30px 0;
  border-style: solid;
  border-color: rgb(74, 92, 67) #fff;
  transition: 0.3s;
  border-radius: 0 0 0 4px;
}

.box {
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
    0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06),
    0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086),
    0 100px 80px rgba(0, 0, 0, 0.12);
}

.folded_corner {
  position: relative;
  width: 100%;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
  height: auto;
  border-radius: 5px;

  /* background: #58a; */
  background: linear-gradient(
        to left bottom,
        transparent 50%,
        rgba(194, 193, 193, 0.4) 0
      )
      no-repeat 100% 0 / 2em 2em,
    linear-gradient(-135deg, transparent 1.5em, rgb(255, 255, 255) 0);

  /* -webkit-filter: drop-shadow(20px 30px rgba(0, 0, 0, 0.1)); */
  /* filter: drop-shadow(20px 30px rgba(0, 0, 0, 0.1)); */
}

/* .folded_corner::before {
          content: " ";
          position: absolute;
          top: 2em;
          right: 0;
          background: linear-gradient(
              to left bottom,
              transparent 50%,
              rgba(0, 0, 0, 0.1) 0
            )
            100% 0 no-repeat;
          width: 2em;
          height: 2em;
          transform: rotate(180deg);
        } */
.some-other-style {
  background: blue;
}

.my-header-style {
  color: #6f8fb9 !important;
}

.containerIframe {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
  /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
